export default "__VITE_ASSET__f877c4cc__"